module.exports = __webpack_public_path__ + "static/media/passbook_first_page.1aed520c.svg";